import { useRouter } from 'next/router';
import { disconnectSSO } from 'lib/sso';
import { useEffect } from 'react';

import { getAbsolutePath, LOGGED_OUT_HOME_PATH } from 'lib/paths';

const DeconnexionPage = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    disconnectSSO({
      targetUrl: getAbsolutePath(LOGGED_OUT_HOME_PATH),
    });
  }, []);

  return <></>;
};

export default DeconnexionPage;
